import sthetoscopeBgImage from "../assets/sthetoscope.jpg";

const styles = theme => ({
  volunteerForm: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100vw",
    height: "100vh",
    backgroundImage: `url(${sthetoscopeBgImage})`,
    backgroundSize: "cover"
  },
  appHeader: {
    position: "absolute"
  },
  formTitle: {
    marginBottom: 15,
    fontFamily: "Roboto, sans-serif",
    fontSize: "1.8rem"
  },
  formContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "90%",
    height: "calc(96% - 100px)",
    marginTop: "2%",
    paddingTop: 25,
    paddingLeft: 40,
    paddingRight: 40
  },
  calendar: {
    flex: 1,
    width: "100%",
    maxHeight: "calc(100% - 100px)"
  }
});

export default styles;
